import { GroupModelSchedules } from "./group.model";

export interface ClassModelSchedules {
  schoolId?: string;
  classId: string;
  className: string;
  campusName: string;
  campusId: string;
  regionId: string;
  regionName: string;
  isTeacher: boolean;
  startDate: string;
  endDate: string;
  groups: GroupModelSchedules[];
  lessonNumber: number;
  unit: number;
  schoolName: string;
}
export interface ClassGroupModel {
  startDate: string;
  endDate: string;
  schoolId: string;
  schoolName: string;
  classId: string;
  className: string;
  unit: number;
  lesson: number;
  groups: Array<{
    groupId: string;
    groupName: string;
  }>;
}

export interface ClassFilter {
  regionId: string;
  schoolId: string;
  campusId: string;
}

export enum ClassFilterSelection {
  Region = 1,
  School = 2,
  Campus = 3,
}

export interface UnitAndLesson {
  unit: number;
  sequence: number[];
  unitId: number;
}

export interface TeacherClassModel extends ClassModelSchedules {
  isActive?: boolean;
}
